import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Trash2 } from 'lucide-react'

interface DeleteConfirmDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  title: string
  description?: string
  itemName?: string
}

const DeleteConfirmDialog = ({
  open,
  onOpenChange,
  onConfirm,
  title,
  description,
  itemName,
}: DeleteConfirmDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="w-[95%] max-w-[400px] rounded-2xl p-6 gap-6 bg-card!">
        <AlertDialogHeader className="space-y-3">
          <div className="mx-auto w-12 h-12 rounded-full bg-red-950 flex items-center justify-center mb-1">
            <Trash2 className="w-6 h-6 text-red-500" />
          </div>
          <AlertDialogTitle
            className="text-center text-xl text-foreground"
            style={{ fontWeight: 700 }}
          >
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription
            className="text-center text-muted-foreground text-sm"
            style={{ fontWeight: 400 }}
          >
            {description ||
              'Are you sure you want to delete this item? This action cannot be undone.'}
            {itemName && (
              <span className="block mt-2 font-medium text-foreground bg-muted py-2 px-3 rounded-lg border border-border">
                "{itemName}"
              </span>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="grid grid-cols-2 gap-3 sm:space-x-0">
          <AlertDialogCancel className="w-full mt-0 h-10 rounded-xl border-border text-foreground font-semibold hover:bg-muted hover:text-foreground transition-colors">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault()
              onConfirm()
              onOpenChange(false)
            }}
            className="w-full h-10 rounded-xl bg-red-500 text-[#FFFFFF] font-semibold hover:bg-red-400 transition-colors border-0"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default DeleteConfirmDialog
